import styled from 'styled-components';

import { BiggerSubtitle, BigSubtitle, SmallParagraph } from '@genially/design-system';

import { PANEL_SURFACE } from '../common/panelColors';

interface GridProps {
  $isExpanded: boolean;
}

export const Grid = styled.div<GridProps>(({ theme: { size }, $isExpanded }) => ({
  display: 'grid',
  gridTemplateColumns: $isExpanded ? '1fr' : 'repeat(2, 1fr)',
  gap: size.units(1),
  paddingBottom: size.units(2),
}));

export const Card = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.half,
  padding: size.units(2),
  borderRadius: size.units(1),
  backgroundColor: PANEL_SURFACE,
}));

export const Value = styled(BigSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const ExpandedValue = styled(BiggerSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const Label = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.primary.disabled(),
}));
